import { gql } from '@apollo/client';

export const MAINTENANCE_RECORDS_LIST = gql`
  query MaintenanceRecordsList($sort: [MaintenanceRecordSort!], $first: Int, $skip: Int) {
    maintenanceRecordsList(sort: $sort, first: $first, skip: $skip) {
      items {
        _description
        category
        cost
        createdAt
        createdBy {
          id
          firstName
          email
          lastName
        }
        description
        id
        performedDate
        scheduledDate
        updatedAt
     
        maintenanceRecords {
          id
          model
          make
          unitNumber
          status
          updatedAt
          vIN
          year
          licensePlate
          createdAt
        }
      }
      count
    }
  }
`;

export const MAINTENANCE_GET = gql`
  query MaintenanceGet($id: ID!) {
    maintenanceRecordsList(filter: { id: { equals: $id } }) {
      items {
        category
        cost
        createdAt
        deletedAt
        description
        performedDate
        scheduledDate
        id
        createdBy {
          id
          firstName
          email
          lastName
        }
        maintenanceRecords {
          id
          model
          make
          unitNumber
          status
          updatedAt
          vIN
          year
          licensePlate
        }
      }
    }
  }
`;

export const MAINTENANCE_RECORD_CREATE = gql`
  mutation MaintenanceRecordCreate($data: MaintenanceRecordCreateInput!) {
    maintenanceRecordCreate(data: $data) {
      id
    }
  }
`;

export const MAINTENANCE_RECORD_UPDATE = gql`
  mutation MaintenanceRecordUpdate($data: MaintenanceRecordUpdateInput!) {
    maintenanceRecordUpdate(data: $data) {
      id
    }
  }
`;

export const MAINTENANCE_RECORD_DELETE = gql`
  mutation MaintenanceRecordDestroy($filter: MaintenanceRecordKeyFilter!) {
    maintenanceRecordDestroy(filter: $filter) {
      success
    }
  }
`; 